import React from 'react';
import PropTypes from 'prop-types';
import {
  GRANTS_SHAPE,
} from 'config/prop-types';

import './grantsStats.scss';

/**
 * Grants App - Stats component.
 */
export default class GrantsStats extends React.PureComponent {
  /**
   * Start the component
   */
  constructor(props) {
    super(props);
    this.getFundingTotalForFilteredGrants = this
      .getFundingTotalForFilteredGrants.bind(this);
  }

  /**
   * Shows a donation total.
   * @returns {number} Total funding for currently filtered grants.
   */
  getFundingTotalForFilteredGrants() {
    const {
      filteredGrants,
    } = this.props;
    const filteredGrantsAmounts = filteredGrants.map((item) => {
      const itemAmount = parseInt(item.amount, 10);
      if (! Number.isNaN(itemAmount)) {
        return itemAmount;
      }
      return 0;
    });
    const filteredGrantsTotal = filteredGrantsAmounts
      .reduce((prev, next) => prev + next, 0);
    const total = (filteredGrantsTotal || 0);
    return total;
  }

  /**
   * Renders this component.
   * @returns {object} Component markup.
   */
  render() {
    const {
      filteredGrants,
    } = this.props;

    if (! filteredGrants) {
      return false;
    }

    // Don't add total if user isn't logged in.
    const userLoggedIn = document.body.classList.contains('logged-in');
    const fundingTotal = userLoggedIn ?
      this.getFundingTotalForFilteredGrants() : 0;

    return (
      <div className="grants__stats grants-stats">
        <ul>
          {/* Donation Totals */}
          {userLoggedIn && 0 <= fundingTotal && (
            <li className="grants-stats__item">
              <span className="grants-stats__figure">
                <span>$</span>
                {fundingTotal.toLocaleString()}
              </span>
              <span className="grants-stats__label">
                Granted
              </span>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

GrantsStats.propTypes = {
  filteredGrants: PropTypes.PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.shape(GRANTS_SHAPE)),
  ]).isRequired,
};
